<template>
  <span class="ago pl-2">{{ timeAgo }}</span>
</template>
<script setup lang="ts">import { computed as _computed } from 'vue';

import { format as timeAgoFormat } from "timeago.js";

withDefaults(defineProps<{
  timestamp: number;
}>(), {  })

const timeAgo = _computed(() => timeAgoFormat(__props.timestamp * 1000));
</script>
<style scoped lang="scss">
.ago {
  float: right;
  color: grey;
  font-size: smaller;
}
</style>
